import { ReactNode } from "react";
import { StyleSheet, View } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";

interface SettingFieldWrapperProps {
  title: string;
  subTitle?: string;
  children: ReactNode;
  childrenSlot?: "new-line" | "in-line";
  useTranslation?: boolean;
}

export const SettingFieldWrapper = ({
  children,
  childrenSlot = "new-line",
  title,
  subTitle,
  useTranslation = true,
}: SettingFieldWrapperProps) => {
  const { isLarge } = useResponsiveScreen();

  const containerStyle = [
    styles.container,
    childrenSlot === "in-line" && styles.inlineInput,
    !isLarge && { flexDirection: "column" },
  ];
  return (
    <View style={containerStyle}>
      <View style={styles.titleSection}>
        <CustomText
          text={title}
          useTranslationText={useTranslation}
          style={styles.titleText}
          accessibilityLabel={title}
          aria-level="3"
          role="heading"
        />
        {subTitle != null && subTitle !== "" && (
          <CustomText text={subTitle} useTranslationText={useTranslation} style={styles.subTitleText} />
        )}
      </View>
      <View style={[styles.inputSection, childrenSlot === "new-line" && { width: "100%" }]}>{children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    gap: 8,
    alignItems: "flex-start",
  },
  inlineInput: {
    flexDirection: "row",
    gap: 16,
  },
  titleSection: {
    flex: 1,
    display: "flex",
    gap: 2,
  },
  titleText: {
    color: "#101828",
    fontSize: 14,
    fontWeight: 500,
  },
  subTitleText: {
    color: "#475467",
    fontSize: 12,
    textWrap: "balance",
  },
  inputSection: {
    flexShrink: 0,
  },
});
